var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"2","fill":"var(--v-grey-darken-1)"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }